import React from 'react';

export const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 16.12 16.12"
      {...props}
    >
      <path
        fill="#fff"
        d="M8.06,16.12a8.06,8.06,0,1,1,8.06-8.06A8.06,8.06,0,0,1,8.06,16.12ZM8.06.94a7.13,7.13,0,1,0,7.13,7.12A7.14,7.14,0,0,0,8.06.94Z"
      />

      <path
        fill="#fff"
        d="M9.84,8.43l1.75-1.75A1.26,1.26,0,0,0,9.81,4.9L8.06,6.65,6.31,4.9A1.26,1.26,0,0,0,4.53,6.68L6.28,8.43,4.53,10.18a1.26,1.26,0,0,0,0,1.78h0a1.3,1.3,0,0,0,.89.37A1.26,1.26,0,0,0,6.31,12l1.75-1.75L9.81,12a1.26,1.26,0,0,0,.89.37,1.3,1.3,0,0,0,.89-.37,1.26,1.26,0,0,0,0-1.78h0Z"
      />
    </svg>
  );
};
